"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var ReplyExportFormat;
(function (ReplyExportFormat) {
    ReplyExportFormat["XLSX"] = "XLSX";
    ReplyExportFormat["PDF"] = "PDF";
})(ReplyExportFormat = exports.ReplyExportFormat || (exports.ReplyExportFormat = {}));
function ReplyExportFormatFromJSON(json) {
    return ReplyExportFormatFromJSONTyped(json, false);
}
exports.ReplyExportFormatFromJSON = ReplyExportFormatFromJSON;
function ReplyExportFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ReplyExportFormatFromJSONTyped = ReplyExportFormatFromJSONTyped;
function ReplyExportFormatToJSON(value) {
    return value;
}
exports.ReplyExportFormatToJSON = ReplyExportFormatToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVwbHlFeHBvcnRGb3JtYXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvUmVwbHlFeHBvcnRGb3JtYXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSDs7OztHQUlHO0FBQ0gsSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQ3pCLGtDQUFhLENBQUE7SUFDYixnQ0FBVyxDQUFBO0FBQ2YsQ0FBQyxFQUhXLGlCQUFpQixHQUFqQix5QkFBaUIsS0FBakIseUJBQWlCLFFBRzVCO0FBRUQsU0FBZ0IseUJBQXlCLENBQUMsSUFBUztJQUMvQyxPQUFPLDhCQUE4QixDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztBQUN2RCxDQUFDO0FBRkQsOERBRUM7QUFFRCxTQUFnQiw4QkFBOEIsQ0FBQyxJQUFTLEVBQUUsbUJBQTRCO0lBQ2xGLE9BQU8sSUFBeUIsQ0FBQztBQUNyQyxDQUFDO0FBRkQsd0VBRUM7QUFFRCxTQUFnQix1QkFBdUIsQ0FBQyxLQUFnQztJQUNwRSxPQUFPLEtBQVksQ0FBQztBQUN4QixDQUFDO0FBRkQsMERBRUMifQ==